import { SelectBox } from 'district-ui-client/components/select-box'
import { service } from '@ember/service'
import { t } from 'ember-intl'
import { Tooltip, TooltipInfo } from 'district-ui-client/components/tooltip'
import Component from '@glimmer/component'
import type { IntlService } from 'ember-intl'
import type { SelectOption } from '@blakeelearning/ember-select'
import type GradeSetsService from 'district-ui-client/services/grade-sets'
import type Store from '@ember-data/store'

interface ContentLevelPickerSignature {
  Element: HTMLElement
  Args: {
    contentLevels: number[]
    selected: SelectOption['value']
    onContentLevelChange: (opt: SelectOption) => void
    disabled?: boolean
  }
}

export class ContentLevelPicker extends Component<ContentLevelPickerSignature> {
  @service intl!: IntlService

  @service store!: Store

  @service gradeSets!: GradeSetsService

  get options(): SelectOption[] {
    const allOption = { label: this.intl.t('reporting.scopes.allLevels'), value: 'all' }
    const options = this.args.contentLevels.map((grade) => ({
      label: this.gradeSets.findByPosition(grade)?.fullName,
      value: String(grade),
    }))
    return [allOption, ...options]
  }

  <template>
    <label class="flex flex-col gap-y-1" data-test-content-level-picker ...attributes>
      <span class="text-sm font-medium text-neutral-250">
        {{t "contentLevel"}}
        {{#unless @disabled}}<TooltipInfo
            data-test-content-level-info-tooltip
            @text={{t "reporting.scopes.contentLevelTooltip"}}
          />{{/unless}}
      </span>
      <div>
        <SelectBox
          @style="subtle"
          @options={{this.options}}
          @value={{@selected}}
          @onSelect={{@onContentLevelChange}}
          @disabled={{@disabled}}
        />
        {{#if @disabled}}<Tooltip
            data-test-content-level-disabled-tooltip
            @text={{t "reporting.scopes.disabledFilterTooltip"}}
          />{{/if}}
      </div>
    </label>
  </template>
}
